import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'logos',
    pluginName: 'SETTINGS',
    entityName: 'LOGO',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

export const uploadProgress = (data) => {
    return {
        type: 'LOGOS|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};

// Create logo  action creators
export const createLogoInit = () => {
    return crudActions.createInit();
};
export const createLogoStart = () => {
    return crudActions.createStart();
};
export const createLogoSuccess = createdLogo => {
    return crudActions.createSuccess(createdLogo);
};
export const createLogoFail = error => {
    return crudActions.createFail(error);
};

export const createLogo = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(createLogoInit());
        try {
            let maxSize = 0
            const config = {
                onUploadProgress: progressEvent => {
                    maxSize = Math.round((progressEvent.total / 1024));
                    dispatch(uploadProgress({
                        progress: (Math.round((progressEvent.loaded * 100) / data.get('File').size) < 100 ? Math.round((progressEvent.loaded * 100) / data.get('File').size) : '100'),
                        loadSize: Math.round((progressEvent.total / 1024)) < Math.round((progressEvent.loaded / 1024)) ? Math.round((progressEvent.loaded / 1024)) : Math.round((progressEvent.total / 1024)), maxSize: Math.round((progressEvent.total / 1024)), snackStart: true
                    }))
                }
            }
            dispatch(createLogoStart());
            let res = await rest.post('logos/create', data, config);
            if (res.status === 200) {
                dispatch(createLogoSuccess());
                dispatch(uploadProgress({ progress: 100, loadSize: maxSize, maxSize: maxSize, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Create logo was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(createLogoFail());
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot create logo.'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(createLogoFail());
            return false;
        }
    }
}

// Fetch logo action creators
export const fetchLogoInit = () => {
    return crudActions.fetchInit();
};
export const fetchLogoStart = () => {
    return crudActions.fetchStart();
};
export const fetchLogoSuccess = (fetchLogoCount, listLogoCount) => {
    return crudActions.fetchSuccess(fetchLogoCount, listLogoCount);
};
export const fetchLogoFail = () => {
    return crudActions.fetchFail();
};


export const fetchLogoCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchLogoStart());
        try {
            let countRes = await rest.post("logos/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchLogoSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchLogoFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch logos."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchLogoFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch logos."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchLogo = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchLogoStart());
        try {
            let listRes = await rest.post("logos/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchLogoSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchLogoFail());
            return []

        } catch (error) {
            dispatch(fetchLogoFail());
            return []
        }
    }
}


// Load logo action creators
export const loadLogoInit = () => {
    return crudActions.loadInit();
};
export const loadLogoStart = () => {
    return crudActions.loadStart();
};
export const loadLogoSuccess = loadedLogo => {
    return crudActions.loadSuccess(loadedLogo);
};
export const loadLogoFail = error => {
    return crudActions.loadFail(error);
};
export const loadLogo = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Edit logo  action creators
export const editLogoInit = () => {
    return crudActions.editInit();
};
export const editLogoStart = () => {
    return crudActions.editStart();
};
export const editLogoSuccess = editedLogo => {
    return crudActions.editSuccess(editedLogo);
};
export const editLogoFail = error => {
    return crudActions.editFail(error);
};

export const editLogo = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))

        dispatch(editLogoInit());
        try {
            let maxSize = 0
            const config = {
                onUploadProgress: progressEvent => {
                    maxSize = Math.round((progressEvent.total / 1024));
                    dispatch(uploadProgress({
                        progress: (Math.round((progressEvent.loaded * 100) / data.get('File').size) < 100 ? Math.round((progressEvent.loaded * 100) / data.get('File').size) : '100'),
                        loadSize: Math.round((progressEvent.total / 1024)) < Math.round((progressEvent.loaded / 1024)) ? Math.round((progressEvent.loaded / 1024)) : Math.round((progressEvent.total / 1024)), maxSize: Math.round((progressEvent.total / 1024)), snackStart: true
                    }))
                }
            }
            dispatch(editLogoStart());
            let res = await rest.post('logos/save', data, config);
            if (res.status === 200) {
                dispatch(editLogoSuccess());
                dispatch(uploadProgress({ progress: 100, loadSize: maxSize, maxSize: maxSize, snackStart: false }))

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Edit logo was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(editLogoFail());
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot edit logo.'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(editLogoFail());
            return false;
        }
    }
}

// Bulk delete logo action creators
export const bulkDeleteLogosInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteLogosStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteLogosSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteLogosFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteLogos = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteLogosStart());
        try {
            let res = await rest.post('/logos/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteLogosSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted logos.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteLogosFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete logos."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete logos."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteLogosFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const cleanState = () => {
    return ({
        type: 'CLEAN_STATE',
    });
}
